module.exports = __webpack_public_path__ + "img/team-4.1596d97a.jpg";